import {useEffect, useState, useCallback} from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import {css} from '@emotion/react'
import {isFirefox} from '../util/userAgent'
import {convertDatoCmsImgPathsToLocal} from '../util/datoCmsDataFactory'

import SuccessConfetti from './SuccessConfetti'

const CONTAINER_STYLES = `
    width: 1200px;
    margin: auto;
    padding: 0 1rem 25px;
`

const InstructionsInstallProtection = ({languageCode = `en`}) => {
    const site = useStaticQuery(graphql`
        query InstructionsInstallProtection {
            site {
                siteMetadata {
                    ...ProtectionSuccess
                }
            }
        }
    `)

    const {successFirefoxPreviewImage, successSection1Description} = site.site.siteMetadata.privacyprotect[languageCode]

    const [instructionImageComponent, setInstructionImageComponent] = useState(null)
    const [instructionStep] = useState(0)

    const renderInstructionImage = useCallback(() => {
        if (isFirefox()) {
            setInstructionImageComponent(
                <img
                    src={convertDatoCmsImgPathsToLocal(successFirefoxPreviewImage.url)}
                    alt="extension preview"
                    onLoad={(e) => {
                        e.target.style.opacity = '1'
                    }}
                />,
            )
        }
    }, [successFirefoxPreviewImage.url])

    useEffect(() => {
        renderInstructionImage()
    }, [renderInstructionImage])

    useEffect(() => {
        renderInstructionImage()
    }, [instructionStep, renderInstructionImage])

    return (
        <section
            className="instructions"
            css={css`
                ${CONTAINER_STYLES}
                position: relative;
                h2 {
                    font-weight: 500;
                }
            `}
        >
            <div
                css={css`
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                `}
            >
                <div
                    className="instruction-section"
                    css={css`
                        max-width: 500px;
                        opacity: ${instructionImageComponent ? '1' : '0'};
                        transition: opacity 0.2s ease;
                        p {
                            margin: 2rem 0;
                            line-height: 24px;
                        }
                    `}
                >
                    <SuccessConfetti languageCode={languageCode} />
                    <p>{successSection1Description}</p>
                </div>
                <div
                    className="instruction-video"
                    css={css`
                        img {
                            width: 100%;
                            height: 450px;
                            opacity: 0;
                            transition: opacity 1s ease;
                        }
                    `}
                >
                    {instructionImageComponent}
                </div>
            </div>
        </section>
    )
}

export default InstructionsInstallProtection
